import React, { useState } from "react";
import CustomDropdown from "../../components/CustomComponents/CustomDropdown";
import "./styles/DropdownMenuBtn.scss"

const DropdownMenuBtn = (props) => {
  const {handleCopyClick,handleEditClick,handleViewClick,data,label,handleAddToFavourite,} = props;
  const [menu, setMenu] = useState(false);

  const onEditOrder = () =>{ 
    handleEditClick(data);
    }
  const onViewClick = () =>{ 
    handleViewClick(data);
  }
  const onCopy = () =>{
    handleCopyClick(data);
  }
  const onAddToFavourite = () =>{
    handleAddToFavourite?.(data);
  }
 


  const getType = () => {
    if (data?.purchaseOrderNumber&&data?.purchaseRequisitionNumber&&data?.salesOrderNumber) return "PO";
    if (data?.purchaseRequisitionNumber) return "PR";
  };
  console.log(data)

  const type = getType();

  
  const getItems = () => {
    let items = [
      {
  label:'View Order',onClick: onViewClick,
}
    ];

  
    if (type === "PR") {
      items = [
         {
  label: 'View Order',onClick: onViewClick,
},
    (data?.status==="draft")&&{
          label:'Edit Order',onClick: onEditOrder,
        }
        ,
         (data?.status!=="rejected")&& {
          label: 'Add to Favourite',onClick: onAddToFavourite,
        },
      ];

      if (handleCopyClick) {
        items.push({
          label:'Copy Order',onClick: onCopy,
        });
      }
    }
   return items;
  };

  return (
    <CustomDropdown
      isOpen={menu}
      direction="down"
      toggle={() => setMenu(!menu)}
      items={getItems()}
    />
  );
}
export default DropdownMenuBtn;
